import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type VideoCheckFileT = {
    src: string;
    hasBlankFrames?: boolean;
    checked?: boolean;
    shown?: boolean;
};

interface InitialStateI {
    files: {
        [adId: string]: VideoCheckFileT;
    },
};

const initialState: InitialStateI = {
    files: {},
};

const videoCheckerSlice = createSlice({
    name: 'videoChecker',
    initialState,
    reducers: {
        addFileForChecking: (state, action: PayloadAction<{
            file: VideoCheckFileT, adId: string
        }>) => {
            state.files[action.payload.adId] = action.payload.file;
        },
        clearFileList: (state) => {
            state.files = {};
        },
        setCheckedFileWarningShown: (state, action: PayloadAction<string>) => {
            state.files[action.payload].shown = true;
        },
        removeCheckedFile: (state, action: PayloadAction<string>) => {
            delete state.files[action.payload];
        },
        setHasBlankFrames: (state, action: PayloadAction<{ adId: string, hasBlankFrames: boolean }>) => {
            state.files[action.payload.adId].hasBlankFrames = action.payload.hasBlankFrames;
            state.files[action.payload.adId].checked = true;
        },
    }
})

export const { addFileForChecking, clearFileList, setHasBlankFrames, removeCheckedFile, setCheckedFileWarningShown } = videoCheckerSlice.actions;

export default videoCheckerSlice.reducer;
